import { axiosGet, axiosPost } from '../../../../../react_axios/Axios';
import {
    GET_INETRNET_CONNECTION_DETAILS_ACTION_TYPE,
    INSERT_UPDATE_INTERNET_CONNECTION_ACTION_TYPE,
    getInternetConnectionDetailsUrl,
    insertUpdateInternetConnectionUrl,
    headers,
} from '../../../../../utils/constants';

// ─── Get service items + existing exhibitor quantities + GST ────────────────
export const getInternetConnectionDetails_action = () => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            ExhRegistrationID: sessionStorage.getItem('ExhRegistrationIDSS'),
        };
        const res = await axiosGet(getInternetConnectionDetailsUrl, params, headers);
        dispatch({ type: GET_INETRNET_CONNECTION_DETAILS_ACTION_TYPE, payload: res });
        return Promise.resolve(res);
    } catch (error) {
        return Promise.reject(error);
    }
};

// ─── Save exhibitor service item entries via UDT ─────────────────────────────
// serviceList: [{ InternetConnectionMasterID, InternetConnectionDetailID, Quantity, Amount }]
export const insertUpdateInternetConnection_action =
    (serviceList, noOfVoucher, noOfPort, noOfPublicIP, duration, remark, isAgree, ManualFormID, ServiceID, VendorDetails) =>
        async (dispatch) => {
            try {
                const params = {
                    UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
                    ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
                    ExhibitionName: sessionStorage.getItem('sessionExhibitionName'),
                    ExhRegistrationID: sessionStorage.getItem('ExhRegistrationIDSS'),
                    serviceList: serviceList || [],
                    noOfVoucher: noOfVoucher || 0,
                    noOfPort: noOfPort || 0,
                    noOfPublicIP: noOfPublicIP || 0,
                    duration: duration || null,
                    Remark: remark || '',
                    Is_Agree: isAgree,
                    ManualFormID,
                    ServiceID,
                    VendorDetails,
                };
                const res = await axiosPost(insertUpdateInternetConnectionUrl, params, headers);
                dispatch({ type: INSERT_UPDATE_INTERNET_CONNECTION_ACTION_TYPE, payload: res });
                return Promise.resolve(res);
            } catch (error) {
                return Promise.reject(error);
            }
        };
